import React from 'react';
import { BRAND } from '../../../../constants/main';
import { StockModelCardCaptionStyledAC } from './AC/StockModelCardCaptionStyled.AC';
import { StockModelCardCaptionStyledAP } from './AP/StockModelCardCaptionStyled.AP';
import { StockModelCardCaptionStyledDS } from './DS/StockModelCardCaptionStyled.DS';
import { StockModelCardCaptionStyled } from './StockModelCardCaptionStyled';
import { SC } from '../../../../styles/theme';
import { BrandTypes } from '../../../../types/brands';

export type StockModelCardCaptionProps = SC & {
    imageUrl?: string;
    color?: string;
    interior?: string;
    imageAlt?: string;
    isColorAndInteriorDisplayed: boolean;
};

const StockModelCardCaption = (props: StockModelCardCaptionProps) => {
    if (BRAND === BrandTypes.AC) return <StockModelCardCaptionStyledAC {...props} />;
    if (BRAND === BrandTypes.AP) return <StockModelCardCaptionStyledAP {...props} />;
    if (BRAND === BrandTypes.DS) return <StockModelCardCaptionStyledDS {...props} />;
    return <StockModelCardCaptionStyled {...props} />;
};

export default StockModelCardCaption;
